/**
 * Auto-format US phone numbers as (XXX) XXX-XXXX.
 * Strips non-digits, then formats if 10 digits.
 * Formats progressively as the user types.
 */
export function formatPhone(value: string): string {
  const digits = value.replace(/\D/g, '');
  const d = digits.length === 11 && digits[0] === '1' ? digits.slice(1) : digits;
  if (d.length === 0) return '';
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6, 10)}`;
}

export const PHONE_METHODS = new Set(['cell_phone', 'landline', 'text_sms']);

export function isPhoneMethod(method: string): boolean {
  return PHONE_METHODS.has(method);
}
